import { InputLabel } from "@mui/material";
import { styled } from "@mui/system";

export const StyledSelect = styled("div")(({ theme }) => ({
  ".select-label": {
    fontFamily: "Lexend",
    fontSize: "12px",
    fontWeight: "400",
    lineHeight: "15px",
    margin: "5px 0px",
    fontstyle: "normal",
    color: theme.palette.primary.main,
  },
  "& .MuiFormHelperText-root": {
    fontFamily: "Lexend",
    fontStyle: "normal",
    fontWeight: "400",
    fontSize: "12px",
    lineHeight: "20px",
  },
  "& .MuiInputBase-root": {
    background: theme.palette.customColor.white,
    padding: "0 10px !important",
    minHeight: "40px",
    borderRadius: "0px !important",
  },

  "& .MuiInputBase-input": {
    borderRadius: "0px !important",
    background: theme.palette.customColor.white,
    padding: "2px 4px",
    fontSize: "14px !important",
    fontWeight: "400",
  },

  ".Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderWidth: "1px !important",
    borderColor: `gray !important
    `,
  },
  ".MuiAutocomplete-endAdornment": {
    right: "12px !important",
    top: "6px",
  },
  ".placeholder": {
    fontFamily: "lexend",
    opacity: 0.5,
  },
  ".truncate-text": {
    display: "inline-block",
    maxWidth: "150px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    verticalAlign: "middle",
  },
  ".truncate-option": {
    display: "inline-block",
    maxWidth: "200px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    verticalAlign: "middle",
  },
  ".color-option-label": {
    display: "flex",
    alignItems: "center",
  },
}));

export const StyledInputLabel = styled(InputLabel)(({ theme }) => ({
  color: `${theme.palette.primary.main} !important`,
  fontStyle: "normal",
  fontWeight: 400,
  fontSize: "12px",
  lineHeight: "15px",
  margin: "5px 0px",
  "& .required": {
    color: "red",
  },
}));

export const StyledHelperText = styled("div")(({ theme }) => ({
  fontStyle: "normal",
  fontWeight: 400,
  fontSize: "12px",
  lineHeight: "20px",
  color: `${theme.palette.customColor.secondaryRed}`,
  fontFamily: "Lexend",
}));
